import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalPromptDialogComponent } from './modal-prompt.component';

type ActionWhenConfirmed = (data:any) => boolean;

@Injectable()
export class ModalPromptService{
    constructor(private _dialog: MatDialog) {}

    openModal(callback: ActionWhenConfirmed, returnThisDataIfConfirmed: any, options: PromptOptions = {header: 'Please Confirm', body:'Are you sure you want to perform the requested action?'}) : Subject<any>{
        const ret = new Subject<any>();
        const dialogRef = this._dialog.open(ModalPromptDialogComponent, {
            width: '55%',
            maxWidth: '960px',
            panelClass: 'modal-prompt-dialog-panel',
            disableClose: false,
            data: options
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                if (callback) {
                    callback(returnThisDataIfConfirmed);
                }
                ret.next(returnThisDataIfConfirmed);
            } else {
                // Must be false (not undefined): canDeactivate only blocks when === false
                ret.next(false);
            }
            ret.complete();
        });

        return ret;
    }
 
}

export class PromptOptions{
    header: string;
    body: string;
}